<template>
  <div id="PlugInData" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item>插件数据汇总</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="平台" :label-width="formLabelWidth3">
          <el-select v-model="platform" placeholder="请选择" size="small" clearable>
            <!-- <el-option label="全部" value="" ></el-option> -->
            <el-option v-for="item in platformData" :label="item.dictName" :value="item.dictCode"
              v-show="item.pricename == 'main'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品ID" :label-width="formLabelWidth2">
          <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="itemid"
            placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="店铺名" :label-width="formLabelWidth2">
          <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            v-model="store_name" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="旺旺" :label-width="formLabelWidth3">
          <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            v-model="wangwang" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="提交时间" :label-width="formLabelWidth2">
          <el-date-picker v-model="searchformDate" @change="queryData" type="datetimerange"
            :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            align="right" size="small" width="500px" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="search-btn" @click="theQuery(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </section>
    <div class="page">
      <el-row style="margin-bottom: 5px;">
        <el-col :span="10">
          <el-button style="margin-right: 10px;" type="primary" @click="batchOutage" size="small">下载数据</el-button>
          <el-button style="margin-right: 10px;" @click="batchEnabled" size="small">批量删除</el-button>
          <el-button style="margin-right: 10px;" @click="insertToPlugin" size="small">批量入库</el-button>
        </el-col>
      </el-row>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{ totalNum }}</span>项,已选择<span class="promptFont">{{ openNumber }}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="商品信息" width="500">
          <template slot-scope="scope">
            <div style="float: left;" v-if="scope.row.platform == 'DD'">
              <span v-if="scope.row.store_name" style="float: left;">{{ scope.row.store_name }}</span>
              <img v-if="scope.row.platform" :src='require("@/assets/img/platform/pla_" + scope.row.platform + ".png")' alt
                style="width: 14px;height: 14px;float: left;margin-top: 5px;margin-left: 5px;margin-right: 5px;">
              <ShopType style="float: left;margin-top: 2px;" :shoptype="scope.row.shoptype" v-if="scope.row.shoptype" />
            </div>
            <div style="float: left;" v-else>
              <span v-if="scope.row.store_name" style="float: left;">{{ scope.row.store_name }}</span>
              <span v-if="scope.row.wangwang && scope.row.platform != 'JD'"
                style="float: left;">({{ scope.row.wangwang }})</span>
              <img v-if="scope.row.platform" :src='require("@/assets/img/platform/pla_" + scope.row.platform + ".png")' alt
                style="width: 14px;height: 14px;float: left;margin-top: 5px;margin-left: 5px;margin-right: 5px;">
              <ShopType style="float: left;margin-top: 2px;" :shoptype="scope.row.shoptype" v-if="scope.row.shoptype" />
              <span style="float: left;"
                v-if="!scope.row.wangwang && scope.row.platform != 'JD'">({{ scope.row.store_name }})</span>
            </div>
            <div v-if="scope.row.itemtitle" style="clear: both;">{{ scope.row.itemtitle }}</div>
            <div v-if="scope.row.itemurl" style="clear: both;">
              <a style="text-decoration:none;color: #1890ff;cursor: pointer;" target="_blank" :href="scope.row.itemurl">
                {{ scope.row.itemurl }}
              </a>
            </div>
            <span v-if="scope.row.price">价格：{{ scope.row.price }} </span>
            <span v-if="scope.row.sales_volume && scope.row.platform != 'DD'">销量：{{ scope.row.sales_volume }} </span>
            <span v-if="!scope.row.comments && scope.row.platform != 'DD'">评价：--</span>
            <span v-if="scope.row.comments && scope.row.platform != 'DD'">评价：{{ scope.row.comments }} </span>
            <span v-if="scope.row.send_address && scope.row.platform != 'DD'">发货地：{{ scope.row.send_address }}</span>
            <span v-if="scope.row.platform == 'DD'">评论数：{{ scope.row.comments }}</span>
            <div v-if="scope.row.submit_time">提交时间：{{ scope.row.submit_time | fullTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="限价" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.limit_price">￥{{ scope.row.limit_price }}</div>
            <!-- <div v-if="scope.row.complaint_mode">投诉方式：{{scope.row.complaint_mode}}</div>
            <div v-if="scope.row.complaint_remarks">
              投诉备注：<span style="width: 200px;word-break: break-all;">{{scope.row.complaint_remarks}}</span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <div v-if="scope.row.remarks1">备注1：{{ scope.row.remarks1 }}</div>
            <div v-if="scope.row.remarks2">备注2：{{ scope.row.remarks2 }}</div>
            <div v-if="scope.row.remarks3">备注3：{{ scope.row.remarks3 }}</div>
            <div v-if="scope.row.remarks4">备注4：{{ scope.row.remarks4 }}</div>
            <div v-if="scope.row.remarks5">备注5：{{ scope.row.remarks5 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="鹰智快照">
          <template slot-scope="scope">
            <div @click="picture(scope.row.snapshot_url)" v-if="scope.row.snapshot_url"
              style="color: #108cee;cursor: pointer;">查看快照</div>
            <div v-if="!scope.row.snapshot_url" style="cursor:not-allowed;">查看快照</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="tableData.length > 0">
        <pagination :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]" :total="totalNum"
          @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 批量删除 -->
    <el-dialog :visible.sync="openPhoneShow2" width="20%" title="提示" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要删除勾选的{{ openNumber }}项链接信息吗？</div>
          <div style="font-size: 14px;">删除后
            <span style="color: #e90e24;font-size: 14px;">相关数据信息将无法找回</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" id="dialogPrimary">
        <el-button type="primary" @click="openPhone(1)" size="small">确 定</el-button>
        <el-button @click="openPhoneShow2 = false" style="margin-left: 10px;" size="small" type="TheCustom">取
          消</el-button>
      </div>
    </el-dialog>
    <!-- 批量删除 -->
    <el-dialog :visible.sync="previewPictureShow" width="70%" title="预览">
      <img :src="pictureUrl" alt="" style="width: 100%;">
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewPictureShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取
          消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import aes from "../../../libs/aes";
import pagination from "../../../components/dataTable/pagination";
import ShopType from "@/components/shopType";
export default {
  data() {
    return {
      start_timeformDate: '',
      end_timeformDate: '',
      pictureUrl: '',
      previewPictureShow: false,
      searchformDate: [],
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick: (picker) => {
            this.getRecentDate(picker, 1);
          }
        }, {
          text: '近7日',
          onClick: (picker) => {
            this.getRecentDate(picker, 7);
          }
        }, {
          text: '近15日',
          onClick: (picker) => {
            this.getRecentDate(picker, 15);
          }
        }, {
          text: '近30日',
          onClick: (picker) => {
            this.getRecentDate(picker, 30);
          }
        }, {
          text: '近90日',
          onClick: (picker) => {
            this.getRecentDate(picker, 90);
          }
        }, {
          text: '近365日',
          onClick: (picker) => {
            this.getRecentDate(picker, 365);
          }
        }]
      },
      store_name: '',
      tableData: [],
      multipleSelection: [],
      platformData: [],
      platform: '',
      itemid: '',
      wangwang: '',
      checkAll: 0,
      batchUserIds: '',
      openPhoneShow2: false,
      openNumber: 0,
      totalNum: 100,
      pageNo: 1,
      pageSize: 10,
      currentPage: 1,
      formLabelWidth: '80px',
      formLabelWidth2: '100px',
      formLabelWidth3: '70px',
      rowNum: 0,
      noDate: false,
    }
  },
  created() {
    this.getRecentDate();
  },
  mounted() {
    this.theQuery();
    this.getTree();
  },
  methods: {
    picture(e) {
      this.previewPictureShow = true
      this.pictureUrl = e
    },
    getRecentDate(picker, n) {
      console.log(1111)
      this.noDate = true
      if (!n) {
        n = 7
      }
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if (picker) {
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.searchformDate[0] = end;
        this.searchformDate[1] = end;
        this.start_timeformDate = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10) + ' 00:00:00';
        this.end_timeformDate = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10) + ' 23:59:59';
      } else {
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
        this.start_timeformDate = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10) + ' 00:00:00';
        this.end_timeformDate = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10) + ' 23:59:59';
      }
    },
    queryData(date) {
      if (this.noDate != true) {
        this.start_timeformDate = this.$options.filters['fullTime'](date[0]);
        this.end_timeformDate = this.$options.filters['fullTime'](date[1]);
      }
    },
    getTree() {
      let params = {
        dictcode: 'platform',
        pricename: 'main',
      }
      fetch({
        url: "hcm/sys/GetList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.platformData = data;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    theQuery(e) {
      this.noDate = false
      if (e == 1) {
        this.pageNo = 1
        this.currentPage = 0
      }
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        // start_time: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0, 10) + ' 00:00:00',

        // end_time: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0, 10) + ' 23:59:59',
        start_time: this.start_timeformDate,
        end_time: this.end_timeformDate,
      }
      if (this.itemid) {
        params.itemid = this.itemid;
      }
      if (this.wangwang) {
        params.wangwang = this.wangwang;
      }
      if (this.platform) {
        params.platform = this.platform;
      } else {
        params.platform = ''
      }
      if (this.store_name) {
        params.store_name = this.store_name;
      }
      fetch({
        url: "hcm/plugin/getPluginList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.currentPage = 1
          this.tableData = data.content;
          this.totalNum = data.totalElements;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleAllSelection(row);
          this.rowNum = row.length
          this.checkAll = 2
          this.openNumber = this.totalNum
        });
      } else {
        this.$refs.multipleTable.clearSelection();
        this.checkAll = 1
        this.openNumber = 0
      }
    },
    handleSizeChange(val) {
      this.pageSize = `${val}`
      this.theQuery();
    },
    handleCurrentChange(val) {
      this.pageNo = `${val}`
      this.theQuery();
    },
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.multipleSelection = val;
        if (this.rowNum == val.length && this.checkAll == 2) {
          this.openNumber = this.totalNum
        } else if (val.length != 0) {
          this.openNumber = val.length
          this.checkAll = 1
        }
      } else {
        this.multipleSelection = val
        this.checkAll = 1
        this.openNumber = val.length
      }
    },
    batchEnabled() {
      if (this.multipleSelection.length != 0) {
        this.openPhoneShow2 = true;
        if (this.checkAll == 2) {
          this.openNumber = this.totalNum;
        } else {
          this.openNumber = this.multipleSelection.length;
        }
      } else {
        this.$message({
          message: '请选择要删除的链接',
          type: 'warning'
        });
      }
    },
    // 下载数据
    batchOutage() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        start_time: this.start_timeformDate,
        end_time: this.end_timeformDate,
        // start_time: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0, 10) + ' 00:00:00',
        // end_time: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0, 10) + ' 23:59:59',
      }
      if (this.itemid) {
        params.itemid = this.itemid;
      }
      if (this.wangwang) {
        params.wangwang = this.wangwang;
      }
      if (this.platform) {
        params.platform = this.platform;
      }
      if (this.store_name) {
        params.store_name = this.store_name;
      }
      fetch({
        url: "hcm/plugin/down_pluginList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "blob"
      })
        .then((res) => {
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '插件汇总.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    },
    openPhone(e) {
      var arr = [];
      this.multipleSelection.forEach((val, index, val_arr) => {
        arr.push(val.id)
      });
      console.log(arr)
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        start_time: this.start_timeformDate,
        end_time: this.end_timeformDate,
      }
      if (this.itemid) {
        params.itemid = this.itemid;
      }
      if (this.wangwang) {
        params.wangwang = this.wangwang;
      }
      if (this.platform) {
        params.platform = this.platform;
      }
      if (this.store_name) {
        params.store_name = this.store_name;
      }
      if (this.checkAll == 2) {
        params.ids = 'checkAll'
      } else {
        this.batchUserIds = arr.join();
        params.ids = this.batchUserIds
      }
      console.log(params.ids)
      fetch({
        url: "hcm/plugin/deletePluginList",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.theQuery();
          this.openPhoneShow2 = false;
          this.checkAll = 1
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 批量入库操作
    insertToPlugin() {
      if (!this.platform) {
        this.$message({
          message: '请选择平台',
          type: 'warning'
        });
        return
      }
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择要入库的链接',
          type: 'warning'
        });
        return
      }
      
      // 收集选中项的id数组
      var arr = [];
      this.multipleSelection.forEach((val, index, val_arr) => {
        arr.push(val.id)
      });
      // 构建请求参数
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        start_time: this.start_timeformDate,
        end_time: this.end_timeformDate,
      }
      // 添加可选参数
      if (this.itemid) {
        params.itemid = this.itemid;
      }
      if (this.wangwang) {
        params.wangwang = this.wangwang;
      }
      if (this.platform) {
        params.platform = this.platform;
      }
      if (this.store_name) {
        params.store_name = this.store_name;
      }
      // 处理全选/部分选择情况
      if (this.checkAll == 2) {
        params.ids = 'checkAll'
      } else {
        this.batchUserIds = arr.join();
        params.ids = this.batchUserIds
      }
      // 发送批量入库请求
      fetch({
        url: "hcm/plugin/insertToPlugin",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        // 处理响应结果
        if (res.status == '10000') {
          console.log(data,'datadata')
          this.$message({
            message: '入库成功!',
            type: 'success'
          });
          this.checkAll = 1  // 重置全选状态
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },

  components: {
    pagination,
    ShopType
  }
}
</script>
<style scoped lang="scss">
.header {
  width: 100%;
  height: 40px;
  background-color: white;
}

.page {
  padding: 20px;
  margin-top: 10px;
  background-color: white;
}

.headerSize {
  line-height: 28px;
  text-align: right;
}

.prompt {
  height: 28px;
  border: 1px solid #108cee;
  background-color: #e6f7ff;
  border-radius: 5px;
  line-height: 28px;
  margin-bottom: 8px;
  margin-top: 8px;
}

.promptFont {
  color: #108cee;
  font-size: 14px;
  margin-left: 3px;
  margin-right: 3px;
}

.promptFont2 {
  color: #108cee;
  font-size: 14px;
  margin-left: 3px;
  margin-right: 3px;
  cursor: pointer;
}

.block {
  text-align: right;
  margin-top: 20px;
}
</style>
<style lang="scss">
#PlugInData {
  .el-table th {
    background-color: #f3f7ff !important;
  }

  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }

  .el-button+.el-button {
    margin-left: 1px;
  }

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }

  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

  #dialogPrimary {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }

    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }

}
</style>
